module.exports = "pegasus/assets/theme4/medium/5.jpg";